export default __webpack_public_path__ + "static/media/marker-gray-red-yellow.570fdff6.png";